import { render, staticRenderFns } from "./AreaAnswer.vue?vue&type=template&id=78bb303e&scoped=true"
import script from "./AreaAnswer.vue?vue&type=script&lang=js"
export * from "./AreaAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bb303e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78bb303e')) {
      api.createRecord('78bb303e', component.options)
    } else {
      api.reload('78bb303e', component.options)
    }
    module.hot.accept("./AreaAnswer.vue?vue&type=template&id=78bb303e&scoped=true", function () {
      api.rerender('78bb303e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/learningStylesRelevantToPerformance/components/AreaAnswer.vue"
export default component.exports